export default "__VITE_ASSET__BmOIpJ5h__"